<template>
  <div id="home-featured" class="fade-in-fast">
    <div class="featured-tabs">
      <ul class="featured-tabs__nav">
        <li v-for="item in featuredSectionData"
            :key="item.id"
            class="featured-tabs__nav__item"
        >
          <a
            href="#"
            class="featured-tabs__nav__link"
            :class="{ active: activeTab == item.id }"
            @click.prevent="activeTab = item.id"
          >
            {{ item.title }}
          </a>
        </li>
      </ul>
      <div class="featured-tabs__pane">
        <LoadingItems v-if="loading" />
        <Transition name="fade" mode="out-in">
          <keep-alive>
            <HomeFeaturedCarousel
              v-if="staffPicks.length && activeTab == 1"
              :key="activeTab"
              carousel-id="staff-picks"
              :featured-data="staffPicks"
            />
            <HomeFeaturedCarousel
              v-else-if="latestEpisodes.length && activeTab == 2"
              :key="activeTab"
              carousel-id="latest-episodes"
              :featured-data="latestEpisodes"
            />
          </keep-alive>
        </Transition>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import HomeFeaturedCarousel from '@/components/sections/HomeFeaturedCarousel.vue';
import LoadingItems from '@/components/ui/LoadingItems.vue';
export default {
  name: 'HomeFeatured',
  components: {
    HomeFeaturedCarousel,
    LoadingItems
  },
  data: () => ({
    loading: false,
    staffPicks: [],
    latestEpisodes: [],
    latestEpisodesLoaded: false,
    activeTab: 1,
    featuredSectionData: [
      { id: 1, title: 'Staff Picks' },
      { id: 2, title: 'Latest' }
    ]
  }),
  watch: {
    activeTab(value) {
      if (value == 2 && !this.latestEpisodesLoaded) this.getLatestEpisodes();
      else return;
    }
  },
  mounted() {
    this.getStaffPicks();
  },
  methods: {
    getStaffPicks() {
      this.loading = true;
      axios
        .get(this.$router.options.api + '/front/get-staff-picks')
        .then(response => (this.staffPicks = response.data))
        .catch(error => console.error(error))
        .finally(() => (this.loading = false));
    },
    getLatestEpisodes() {
      this.loading = true;
      axios
        .get(this.$router.options.api + '/episode/latest-episodes?size=10&page=0')
        .then(response => (this.latestEpisodes = response.data.content))
        .catch(error => console.error(error))
        .finally(() => (this.loading = false));
      this.latestEpisodesLoaded = true;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_home-featured.scss';
</style>
